import { styled } from '@mui/material/styles';
import { Role } from '@bloomays-lib/types.shared';
import { Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores';
import { PageHeader } from '../molecules/PageHeader';

const Primes = () => {
  const { t } = useTranslation(['primes']);
  const auth = useAuthStore((state) => state.auth);

  const isAdmin = auth?.user?.roles?.includes(Role.Admin) || false;
  const isSystem = auth?.user?.roles?.includes(Role.System) || false;

  if (!isAdmin && !isSystem) {
    return <Navigate to="/forbidden/norole" replace />;
  }

  return (
    <Container>
      <PageHeader id="titlePrimes" title={t('title')} />
      <Outlet />
    </Container>
  );
};

export default Primes;

const Container = styled('div')(() => ({
  margin: 'auto',
  width: '90%',
}));
